import {RouteConfig} from 'vue-router';
import { Routes } from '@/router/Routes';
import { I18NGetter } from '@/services/enumTranslator/I18NGetter';
import EnvironmentService from '@/env/EnvironmentService';
const Filemanager = () => import(/* webpackChunkName: "Filemanager" */ '@/modules/filemanager/views/Filemanager.vue');
const FilemanagerFile = () => import(/* webpackChunkName: "Filemanager" */ '@/modules/filemanager/views/FilemanagerFile.vue');

const FilemanagerRoutes: Array<RouteConfig> = [
  {
    path: 'filemanager/:path?',
    name: Routes.FILEMANAGER.FILEMANAGER,
    component: Filemanager,
    meta: {
      title: I18NGetter().KnowledgeBaseSection.knowledge_repository,
      icon: 'mdi-file-multiple',
      mode: 'crm',
      condition: () => EnvironmentService.Environment.isAppDomain().LENDI_PL,
    },
  },
];

// Strona pojedynczego pliku — cel linków z „Skopiuj link" (np. wklejanych do newsów).
// Celowo poza sekcją „Baza wiedzy" i bez `mode`: nie trafia do menu, a o dostępie do pliku
// decyduje backend (403), nie dostęp do modułu.
export const FilemanagerFileRoute: RouteConfig = {
  path: 'filemanager/:shortUrl',
  name: Routes.FILEMANAGER.FILE,
  component: FilemanagerFile,
  meta: {
    returnAfterLogin: true,
    condition: () => EnvironmentService.Environment.isAppDomain().LENDI_PL,
  },
};

export default FilemanagerRoutes;
